import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_ALERT_TOPAY_BY_INVOICE } from "../Schema/Invoice";

const useGetAlertToPayByInvoiceId = ({ invoiceId }) => {
  const [loading, setLoading] = useState(true);
  const [alertData, setAlertData] = useState();

  const { refetch } = useQuery(GET_ALERT_TOPAY_BY_INVOICE, {
    variables: {
      invoiceId: invoiceId,
    },
    onCompleted: ({ getAlertToPayByInvoice }) => {
      setAlertData(getAlertToPayByInvoice);
      setLoading(false);
    },
    onError: ({ message }) => {
      console.log("Error::", message);
    },
  });

  useEffect(() => {
    refetch();
  }, [invoiceId]);

  return { alertData, loading, refetch };
};

export default useGetAlertToPayByInvoiceId;
